import { render, staticRenderFns } from "./FactFindLiabilityMortgage.vue?vue&type=template&id=27005b62&"
import script from "./FactFindLiabilityMortgage.vue?vue&type=script&lang=ts&"
export * from "./FactFindLiabilityMortgage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports